var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('edit',{attrs:{"api":"brands","title":"brand","id":_vm.$route.params.id,"fs":_vm.brandFields,"back":"/admin/brands"},on:{"saved":_vm.saved}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }